/**
 * @generated SignedSource<<2311f5de0b2859e385fbf0c363cdd739>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type agileArticleTwoQuery$variables = {
  limit?: number | null | undefined;
  locale: string;
  urlSlug: string;
};
export type agileArticleTwoQuery$data = {
  readonly articleDetailsCollection: {
    readonly items: ReadonlyArray<{
      readonly bodyTextContainerCollection: {
        readonly items: ReadonlyArray<{
          readonly contentComponentsCollection: {
            readonly items: ReadonlyArray<{
              readonly __typename: "AssetComponent";
              readonly asset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly assetRelatedText: {
                readonly json: any;
              } | null | undefined;
              readonly caption: string | null | undefined;
            } | {
              readonly __typename: "CallOutComponent";
              readonly asset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly callOutText: {
                readonly json: any;
              } | null | undefined;
              readonly icon: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly title: string | null | undefined;
            } | {
              readonly __typename: "CallToAction";
              readonly asset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly ctaText: string | null | undefined;
              readonly dataBlueprintModule: string | null | undefined;
              readonly productCollection: {
                readonly items: ReadonlyArray<{
                  readonly productLogo: {
                    readonly contentType: string | null | undefined;
                    readonly description: string | null | undefined;
                    readonly fileName: string | null | undefined;
                    readonly height: number | null | undefined;
                    readonly name: string | null | undefined;
                    readonly size: number | null | undefined;
                    readonly url: string | null | undefined;
                    readonly width: number | null | undefined;
                  } | null | undefined;
                  readonly productNameReference: {
                    readonly productName: string | null | undefined;
                  } | null | undefined;
                } | null | undefined>;
              } | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly valueProposition: string | null | undefined;
            } | {
              readonly __typename: "EmbeddedVideoAsset";
              readonly embedAssetOverlay: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly embedded: string | null | undefined;
              readonly embeddedVideoAssetName: string | null | undefined;
            } | {
              readonly __typename: "ProTipComponent";
              readonly name: string | null | undefined;
              readonly proTipText: string | null | undefined;
            } | {
              readonly __typename: "QuestionComponent";
              readonly answer: {
                readonly json: any;
              } | null | undefined;
              readonly answerAsset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly questionTitle: string | null | undefined;
            } | {
              readonly __typename: "TextComponent";
              readonly name: string | null | undefined;
              readonly text: {
                readonly json: any;
              } | null | undefined;
            } | {
              readonly __typename: "TwitterComponent";
              readonly tweetText: string | null | undefined;
              readonly twitterComponentName: string | null | undefined;
              readonly twitterUrl: string | null | undefined;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined>;
          } | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly nextBestActionCollection: {
        readonly items: ReadonlyArray<{
          readonly __typename: "MicrositeArticle";
          readonly articleBanner: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly name: string | null | undefined;
            readonly size: number | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly articleName: string | null | undefined;
          readonly description: string | null | undefined;
          readonly title: string | null | undefined;
          readonly urlSlug: string | null | undefined;
        } | {
          readonly __typename: "Tutorial";
          readonly description: string | null | undefined;
          readonly name: string | null | undefined;
          readonly title: string | null | undefined;
          readonly tutorialBanner: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly name: string | null | undefined;
            readonly size: number | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly urlSlug: string | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined>;
      } | null | undefined;
      readonly upNext: {
        readonly __typename: "MicrositeArticle";
        readonly articleBanner: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly name: string | null | undefined;
          readonly size: number | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly articleName: string | null | undefined;
        readonly articleTitle: string | null | undefined;
        readonly description: string | null | undefined;
        readonly urlSlug: string | null | undefined;
      } | {
        readonly __typename: "MicrositeTopicOverview";
        readonly bannerImage: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly name: string | null | undefined;
          readonly size: number | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly description: string | null | undefined;
        readonly name: string | null | undefined;
        readonly subtitle: string | null | undefined;
        readonly title: string | null | undefined;
        readonly topicOverviewId: string;
        readonly urlSlug: string | null | undefined;
      } | {
        readonly __typename: "Tutorial";
        readonly description: string | null | undefined;
        readonly tutorialBanner: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly name: string | null | undefined;
          readonly size: number | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly tutorialName: string | null | undefined;
        readonly tutorialTitle: string | null | undefined;
        readonly urlSlug: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type agileArticleTwoQuery = {
  response: agileArticleTwoQuery$data;
  variables: agileArticleTwoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 1,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "urlSlug",
            "variableName": "urlSlug"
          }
        ],
        "kind": "ObjectValue",
        "name": "articleRef"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 15
  }
],
v5 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "supportingConceptNameExternal",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 20
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": "embeddedVideoAssetName",
  "args": null,
  "kind": "ScalarField",
  "name": "embeddedVideoAssetNameExternal",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "embedded",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = [
  (v10/*: any*/),
  {
    "alias": "name",
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "embedAssetOverlay",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "textComponentNameExternal",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "TextComponentText",
  "kind": "LinkedField",
  "name": "text",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": "caption",
  "args": null,
  "kind": "ScalarField",
  "name": "assetCaption",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetComponentAssetRelatedText",
  "kind": "LinkedField",
  "name": "assetRelatedText",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "proTipNameExternal",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proTipText",
  "storageKey": null
},
v21 = {
  "alias": "twitterComponentName",
  "args": null,
  "kind": "ScalarField",
  "name": "twitterComponentExternalName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tweetText",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterUrl",
  "storageKey": null
},
v24 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleExternal",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v26 = {
  "alias": "url",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueProposition",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataBlueprintModule",
  "storageKey": null
},
v29 = {
  "alias": "asset",
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "ctaAsset",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "CallToActionProductCollection",
  "kind": "LinkedField",
  "name": "productCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductListing",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductName",
          "kind": "LinkedField",
          "name": "productNameReference",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "productLogo",
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": (v11/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productCollection(limit:1)"
},
v31 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "callOutComponentTitleExternal",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "CallOutComponentCallOutText",
  "kind": "LinkedField",
  "name": "callOutText",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": "icon",
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "callOutComponentIcon",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": "questionTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "questionTitleExternal",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "QuestionComponentAnswer",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "answerAsset",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v37 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 2
  }
],
v38 = {
  "alias": "articleName",
  "args": null,
  "kind": "ScalarField",
  "name": "articleNameExternal",
  "storageKey": null
},
v39 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "articleTitle",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "articleBanner",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v42 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialNameExternal",
  "storageKey": null
},
v43 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialTitle",
  "storageKey": null
},
v44 = {
  "alias": "description",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialDescription",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "tutorialBanner",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": "topicOverviewId",
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v47 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "topicNameExternal",
  "storageKey": null
},
v48 = {
  "alias": "subtitle",
  "args": null,
  "kind": "ScalarField",
  "name": "topicSubtitle",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "bannerImage",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v50 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "topicTitle",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "articleTitle",
  "storageKey": null
},
v52 = {
  "alias": "tutorialName",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialNameExternal",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialTitle",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "agileArticleTwoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ArticleDetailsCollection",
        "kind": "LinkedField",
        "name": "articleDetailsCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleDetails",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "ArticleDetailsBodyTextContainerCollection",
                "kind": "LinkedField",
                "name": "bodyTextContainerCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailParagraphWrapper",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "DetailParagraphWrapperContentComponentsCollection",
                        "kind": "LinkedField",
                        "name": "contentComponentsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "type": "EmbeddedVideoAsset",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v13/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "type": "TextComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "type": "AssetComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "type": "ProTipComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "type": "TwitterComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/)
                                ],
                                "type": "CallToAction",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v16/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "type": "CallOutComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/)
                                ],
                                "type": "QuestionComponent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "contentComponentsCollection(limit:20)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "bodyTextContainerCollection(limit:15)"
              },
              {
                "alias": null,
                "args": (v37/*: any*/),
                "concreteType": "ArticleDetailsNextBestActionCollection",
                "kind": "LinkedField",
                "name": "nextBestActionCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v10/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/)
                        ],
                        "type": "MicrositeArticle",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v41/*: any*/)
                        ],
                        "type": "Tutorial",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "nextBestActionCollection(limit:2)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "upNext",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v10/*: any*/),
                      (v49/*: any*/),
                      (v41/*: any*/),
                      (v50/*: any*/)
                    ],
                    "type": "MicrositeTopicOverview",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v38/*: any*/),
                      (v51/*: any*/),
                      (v10/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/)
                    ],
                    "type": "MicrositeArticle",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v41/*: any*/)
                    ],
                    "type": "Tutorial",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "agileArticleTwoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ArticleDetailsCollection",
        "kind": "LinkedField",
        "name": "articleDetailsCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleDetails",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "ArticleDetailsBodyTextContainerCollection",
                "kind": "LinkedField",
                "name": "bodyTextContainerCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailParagraphWrapper",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "DetailParagraphWrapperContentComponentsCollection",
                        "kind": "LinkedField",
                        "name": "contentComponentsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "type": "EmbeddedVideoAsset",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v13/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "type": "TextComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "type": "AssetComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v19/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "type": "ProTipComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "type": "TwitterComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/)
                                ],
                                "type": "CallToAction",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v16/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "type": "CallOutComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/)
                                ],
                                "type": "QuestionComponent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "contentComponentsCollection(limit:20)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "bodyTextContainerCollection(limit:15)"
              },
              {
                "alias": null,
                "args": (v37/*: any*/),
                "concreteType": "ArticleDetailsNextBestActionCollection",
                "kind": "LinkedField",
                "name": "nextBestActionCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v10/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/)
                        ],
                        "type": "MicrositeArticle",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v41/*: any*/)
                        ],
                        "type": "Tutorial",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "nextBestActionCollection(limit:2)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "upNext",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v10/*: any*/),
                      (v49/*: any*/),
                      (v41/*: any*/),
                      (v50/*: any*/)
                    ],
                    "type": "MicrositeTopicOverview",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v38/*: any*/),
                      (v51/*: any*/),
                      (v10/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/)
                    ],
                    "type": "MicrositeArticle",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v41/*: any*/)
                    ],
                    "type": "Tutorial",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21d59161706ea76a4b5f641c4f27618a",
    "id": null,
    "metadata": {},
    "name": "agileArticleTwoQuery",
    "operationKind": "query",
    "text": "query agileArticleTwoQuery(\n  $limit: Int = 1\n  $urlSlug: String!\n  $locale: String!\n) {\n  articleDetailsCollection(limit: $limit, where: {articleRef: {urlSlug: $urlSlug}}, locale: $locale) {\n    items {\n      bodyTextContainerCollection(limit: 15) {\n        items {\n          name: supportingConceptNameExternal\n          contentComponentsCollection(limit: 20) {\n            items {\n              __typename\n              ... on EmbeddedVideoAsset {\n                __typename\n                embeddedVideoAssetName: embeddedVideoAssetNameExternal\n                embedded\n                embedAssetOverlay {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n              ... on TextComponent {\n                __typename\n                name: textComponentNameExternal\n                text {\n                  json\n                }\n              }\n              ... on AssetComponent {\n                __typename\n                asset {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n                caption: assetCaption\n                assetRelatedText {\n                  json\n                }\n              }\n              ... on ProTipComponent {\n                __typename\n                name: proTipNameExternal\n                proTipText\n              }\n              ... on TwitterComponent {\n                __typename\n                twitterComponentName: twitterComponentExternalName\n                tweetText\n                twitterUrl\n              }\n              ... on CallToAction {\n                __typename\n                title: ctaTitleExternal\n                ctaText\n                url: ctaUrl\n                valueProposition\n                dataBlueprintModule\n                asset: ctaAsset {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n                productCollection(limit: 1) {\n                  items {\n                    productNameReference {\n                      productName\n                    }\n                    productLogo: icon {\n                      description\n                      name: title\n                      url\n                      width\n                      height\n                      size\n                      fileName\n                      contentType\n                    }\n                  }\n                }\n              }\n              ... on CallOutComponent {\n                __typename\n                title: callOutComponentTitleExternal\n                callOutText {\n                  json\n                }\n                asset {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n                icon: callOutComponentIcon {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n              ... on QuestionComponent {\n                __typename\n                questionTitle: questionTitleExternal\n                answer {\n                  json\n                }\n                answerAsset {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n            }\n          }\n        }\n      }\n      nextBestActionCollection(limit: 2) {\n        items {\n          __typename\n          ... on MicrositeArticle {\n            __typename\n            articleName: articleNameExternal\n            title: articleTitle\n            description\n            articleBanner {\n              description\n              name: title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n            urlSlug\n          }\n          ... on Tutorial {\n            __typename\n            name: tutorialNameExternal\n            title: tutorialTitle\n            description: tutorialDescription\n            tutorialBanner {\n              description\n              name: title\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n            urlSlug\n          }\n        }\n      }\n      upNext {\n        __typename\n        ... on MicrositeTopicOverview {\n          __typename\n          topicOverviewId: _id\n          name: topicNameExternal\n          subtitle: topicSubtitle\n          description\n          bannerImage {\n            description\n            name: title\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          urlSlug\n          title: topicTitle\n        }\n        ... on MicrositeArticle {\n          __typename\n          articleName: articleNameExternal\n          articleTitle\n          description\n          articleBanner {\n            description\n            name: title\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          urlSlug\n        }\n        ... on Tutorial {\n          __typename\n          tutorialName: tutorialNameExternal\n          tutorialTitle\n          description: tutorialDescription\n          tutorialBanner {\n            description\n            name: title\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          urlSlug\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "008a2b29d7c2a63989cbf3e865054b8e";

export default node;
